import { render } from "./CustomFieldEditPage.vue?vue&type=template&id=72d4fb78"
import script from "./CustomFieldEditPage.vue?vue&type=script&lang=js"
export * from "./CustomFieldEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__